export const SUBSCRIBER_COLUMN_ID = "subscriber"
export const SUBSCRIBED_WELLS_COLUMN_ID = "well"
export const EMAIL_COLUMN_ID = "email"
export const TEXT_COLUMN_ID = "text"
export const METRIC_COLUMN_ID = "metric"
export const RULE_NAME_COLUMN_ID = "ruleName"
